import api from './http'

/* *****뉴스룸-보도자료 FRONT API***** */

// 공지사항 목록 조회
const getNotice = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/notice', data)
}

// 공지지사항 상세 조회
const getNoticeDetail = (noticeSeq, callback, errorHandler) => {
  return api.getPromise('GET', `/api/notice/${noticeSeq}/detail/`)
}

// 공지사항 링크 공유 상세 조회
const getNoticeLink = (data = null, callback, errorHandler) => {
  return api.getPromise('GET', '/api/notice/detail', data)
}

export default {
  getNotice,
  getNoticeDetail,
  getNoticeLink,
}
